import React, { Component } from 'react';
import FooterLinkIdentifiers from '../../../../constants/FooterLinkIdentifiers';
import ReportSections from '../../constants/ReportSections';
import style from './style/links.scss';


export default class Links extends Component {
    constructor(props) {
        super(props);

        this.handleOpenPage = this.handleOpenPage.bind(this);
    }

    handleOpenPage(footerElementIdentifier) {
        this.props.showReportOverlay(ReportSections.ABOUT_REPORT, footerElementIdentifier);
    }

    render() {
        const { i18nParticipation } = this.props;

        return (
            <div>
                <p className={ style.title }>
                    { i18nParticipation.report_footer_report }
                </p>
                <p className={ style.report_footer_link } onClick={ () => this.handleOpenPage(FooterLinkIdentifiers.REPORT_ABOUT_THIS_REPORT) }>
                    { i18nParticipation.report_about_this_report }
                </p>
                <p className={ style.report_footer_link } onClick={ () => this.handleOpenPage(FooterLinkIdentifiers.REPORT_VALIDITY) }>
                    { i18nParticipation.report_validity }
                </p>
                <p className={ style.report_footer_link } onClick={ () => this.handleOpenPage(FooterLinkIdentifiers.REPORT_DISCLAIMER) }>
                    { i18nParticipation.report_disclaimer }
                </p>
            </div>
        );
    }
}
